'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const PersonStatisticsViewModel=require('../../../dist-es6/client/viewModels/personStatisticsViewModel');
const NotificationType=require('pulsar-dashboard-core/dist-es6/domain/notificationType');
const ThresholdStatus=require('pulsar-dashboard-core/dist-es6/domain/thresholdStatus');
const AlertStatusCache=require('../../../dist-es6/client/viewModels/alertStatusCache');
const ex=require('pulsar-utils/dist-es6/ex');
const timespan=require('pulsar-utils/dist-es6/time/timespan');
const Formatters=require('../../../dist-es6/client/formatters');

const THREE_HOURS_IN_MS=timespan.fromHours(3).totalMilliseconds();let

DashboardPersonViewModel=function(_PersonStatisticsView){_inherits(DashboardPersonViewModel,_PersonStatisticsView);
function DashboardPersonViewModel(){_classCallCheck(this,DashboardPersonViewModel);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key]}var _this=_possibleConstructorReturn(this,
_PersonStatisticsView.call.apply(_PersonStatisticsView,[this].concat(args)));
_this._thresholdCacheValue=void 0;
_this._statusCache=new AlertStatusCache(function(nt){return _this._thresholdStatusFor(nt)});
_this._isStaleValue=void 0;
_this._currentStatusSource='lastKnownStatus';return _this;
}DashboardPersonViewModel.prototype.















_thresholdStatusFor=function _thresholdStatusFor(notificationType){
return ThresholdStatus.fromScoreAndThreshold(this.fatigueAlertScore,this._thresholdCache.get(notificationType));
};DashboardPersonViewModel.prototype.

thresholdFor=function thresholdFor(notificationType){
return this._thresholdCache.get(notificationType);
};DashboardPersonViewModel.prototype.

thresholdStatusFor=function thresholdStatusFor(notificationType){
return this._statusCache.get(notificationType);
};_createClass(DashboardPersonViewModel,[{key:'_thresholdCache',get:function(){if(!_.exists(this._thresholdCacheValue)){const recentFatigueHistory={averageDailyLow:this.averageDailyLow,averageDailyHigh:this.averageDailyHigh,topDailyHighs:this.topDailyHighs};this._thresholdCacheValue=ThresholdStatus.getEffectiveThresholdsForMultipleGroups(this.groupMembershipsAtScope,recentFatigueHistory)}return this._thresholdCacheValue}},{key:'fatigueAlertScore',get:function()

{
return _.get(this,this._currentStatusSource+'.fatigue');
}},{key:'lastKnownStatus',get:function()

{
return this._statistics.lastKnownStatus;
}},{key:'lastKnownDutyStatus',get:function()

{
return Formatters.dutyStatusFromLastKnownStatus(this.lastKnownStatus);
}},{key:'lastKnownLocationDescription',get:function()

{
return this.lastKnownStatus.location.description;
}},{key:'averageDailyLow',get:function()

{
return ex(this,this._currentStatusSource+'.statistics.recentHistory.fatigue.averageDailyLow').otherwise(null);
}},{key:'averageDailyHigh',get:function()

{
return ex(this,this._currentStatusSource+'.statistics.recentHistory.fatigue.averageDailyHigh').otherwise(null);
}},{key:'topDailyHighs',get:function()

{
return ex(this,this._currentStatusSource+'.statistics.recentHistory.fatigue.topDailyHighs').otherwise(null);
}},{key:'estimatesAsOfTime',get:function()

{
return this._statistics.estimatesAsOfTime;
}},{key:'isStale',get:function()

{
if(!_.exists(this._isStaleValue)){
this._isStaleValue=_.exists(this._statistics[this._currentStatusSource].time)&&Date.now()-this._statistics[this._currentStatusSource].time.getTime()>THREE_HOURS_IN_MS;
}

return this._isStaleValue;
}},{key:'timeOfLastPointBeforeTruncation',get:function()

{
if(_.exists(this._timeOfLastPointBeforeTruncation)){
return this._timeOfLastPointBeforeTruncation;
}

const currentStatus=this._statistics[this._currentStatusSource];

const{estimatesAsOfTime:estimatesAsOfTime,currentHosStatus:currentHosStatus}=this;

if(!_.exists(currentStatus,'time')||!_.exists(estimatesAsOfTime)){
return this._timeOfLastPointBeforeTruncation=!1;
}

if(_.exists(currentHosStatus)){
return this._timeOfLastPointBeforeTruncation=currentStatus.time.getTime()-currentHosStatus.time.getTime()===EightHoursInMilliseconds?
currentHosStatus.time:!1;

}else if(currentStatus.time.getTime()<estimatesAsOfTime.getTime()){
return this._timeOfLastPointBeforeTruncation=new Date(currentStatus.time.getTime()-EightHoursInMilliseconds);
}

return this._timeOfLastPointBeforeTruncation=!1;
}}]);return DashboardPersonViewModel}(PersonStatisticsViewModel);


const EightHoursInMilliseconds=timespan.fromHours(8).totalMilliseconds();

module.exports=DashboardPersonViewModel;
//# sourceMappingURL=dashboardPersonViewModel.js.map
